export const generateDynamicExcelFileName = (lang, prefixType = "Checks") => {
    const now = new Date();
    const date = `${now.getDate()}_${now.getMonth() + 1}_${now.getFullYear()}`;

    const fileNames = {
        uz: {
            Checks: `Chek_${date}`,
            SmsCount: `SMS_Soni_${date}`,
        },
        ru: {
            Checks: `Чеки_${date}`,
            SmsCount: `Количество_СМС_${date}`,
        },
        en: {
            Checks: `Checks_${date}`,
            SmsCount: `SMS_Count_${date}`,
        },
    };

    return fileNames[lang]?.[prefixType] || `${prefixType}_${date}`;
};